module.exports = "/_next/static/images/NCLogo-3332eb8fd5b6183590a553be76c44184.png";